import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'

import avatarSlice from '../features/avatar/avatarSlice'
import balanceSlice from '../features/balance/balanceSlice'
import collectionSlice from '../features/collection/collectionSlice'
import userCollectionSlice from '../features/collection/userCollectionSlice'
import leaderboardSlice from '../features/leaderboard/leaderboardSlice'
import popUpSlice from '../features/popUpSlice/popUpSlice'
import shopItemsSlice from '../features/shopItems/shopItemsSlice'
import epochSlice from '../features/staking/epochSlice'
import stakeInfoSlice from '../features/staking/stakeInfoSlice'
import userSlice from '../features/user/userSlice'
import profileSlice from '../features/userprofile/profileSlice'
import { rootSaga } from '../sagas/sagas'

const sagaMiddleware = createSagaMiddleware()

export default configureStore({
  reducer: {
    galaktikaCollection: collectionSlice,
    userCollection: userCollectionSlice,
    user: userSlice,
    stakeInfo: stakeInfoSlice,
    leaderboard: leaderboardSlice,
    epoch: epochSlice,
    avatar: avatarSlice,
    profile: profileSlice,
    balance: balanceSlice,
    popUp: popUpSlice,
    shopItems: shopItemsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
})

sagaMiddleware.run(rootSaga)
